import React, { createContext, FC, ReactNode } from 'react';
import { GetAllServicesCategoriesSuccessResponse } from '@services/useGetAllServicesCategories';
import { GetAllLanguagesSuccessResponse } from '@services/useGetAllLanguages';
import { GetAllProductStoresSuccessResponse } from '@services/useGetAllProductStores';
import { GetAllServiceStoresSuccessResponse } from '@services/useGetAllServiceStores';
import { GetAllSettingsSuccessResponse } from '@services/useGetAllSettings';
import { GetAllInstagramImagesSuccessResponse } from '@services/useGetAllInstagramImages';
import { GetStoreDetailSuccessResponse } from '@services/useGetStoreDetail';
import { GetAllCarouselDataSuccessResponse } from '@services/useGetAllCarouselData';
import { LoginSuccessResponse } from '@services/useLogin';
import { GetAllProductAttributesByCategorySuccessResponse } from '@services/useGetAllProductAttributesByCategory';
import { GetProductsSuccessResponse } from '@services/useGetProducts';
import { GetProductDetailSuccessResponse } from '@services/useGetProductDetail';
import { GetAllProductsCategoriesSuccessResponse } from '@services/useGetAllProductsCategories';
import { GetStoresSuccessResponse } from '@services/useGetStores';
import { GetCartSuccessResponse } from '@services/useGetCart';
import { GetUserSuccessResponse } from '@services/useGetUser';
import { GetAddressesSuccessResponse } from '@services/useGetMyAccountAddresses';
import { GetMyAccountAddressesEditSuccessResponse } from '@services/useGetMyAccountAddressesEdit';
import { GetMyAccountAddressesDetailSuccessResponse } from '@services/useGetMyAccountAddressesDetail';
import { GetAllGeoDistrictsSuccessResponse } from '@services/useGetAllGeoDistricts';
import { GetAllGeoMunicipalitiesOfDistrictSuccessResponse } from '@services/useGetAllGeoMunicipalitiesOfDistrict';
import { GetCartItemDetailSuccessResponse } from '@services/useGetCartItemDetail';
import { GetMyAccountProductsSuccessResponse } from '@services/useGetMyAccountProducts';
import { GetMyAccountProductDetailSuccessResponse } from '@services/useGetMyAccountProductDetail';
import { GetMyAccountAddressesCreateSuccessResponse } from '@services/useGetMyAccountAddressesCreate';
import { CreateProductSuccessResponse } from '@services/useCreateProduct';
import { GetAllMyAccountStoresSuccessResponse } from '@services/useGetAllMyAccountStores';
import { GetProductCategoryMaxPriceSuccessResponse } from '@services/useGetProductCategoryMaxPrice';
import { GetMyAccountStoreDetailSuccessResponse } from '@services/useGetMyAccountStoreDetail';
import { CreateStoreSuccessResponse } from '@services/useCreateStore';
import { GetAllNearbyPickupSpotsSuccessResponse } from '@services/useGetAllNearbyPickupSpots';
import { GetPickupSpotDetailSuccessResponse } from '@services/useGetPickupSpotDetail';
import { GetAllShippingCountriesSuccessResponse } from '@services/useGetAllShippingCountries';
import { GetHomepageStoresSuccessResponse } from '@services/useGetHomepageStores';
import { GetStoresLocationSuccessResponse } from '@services/useGetStoresLocations';
import { GetAllCategoriesWithProductsSuccessResponse } from '@services/useGetAllCategoriesWithProducts';
import { GetAllPaymentMethodsSuccessResponse } from '@services/useGetAllPaymentMethods';
import { CreateOrderSuccessResponse } from '@services/useCreateOrder';
import { google2FAQrCodeSuccessResponse } from '@services/useGoogle2FAQrCode';
import { GetAllBundlesSuccessResponse } from '@services/useGetAllBundles';
import { GetCampaignBundlesSuccessResponse } from '@services/useGetCampaignBundles';
import { GetBundleDetailSuccessResponse } from '@services/useGetBundleDetail';
import { GetMyOrdersSuccessResponse } from '@services/useGetMyOrders';
import { GetCampaignsSuccessResponse } from '@services/useGetCampaigns';
import { GetMyOrderDetailSuccessResponse } from '@services/useGetMyOrderDetail';
import { GetMyStoresOrdersSuccessResponse } from '@services/useGetMyStoresOrders';
import { GetMyStoresOrderDetailSuccessResponse } from '@services/useGetMyStoresOrderDetail';
import { GetMyAccountWorkerDetailSuccessResponse } from '@services/useGetMyAccountWorkerDetail';
import { GetMyAccountWorkersSuccessResponse } from '@services/useGetMyAccountWorkers';
import { GetMyAccountScheduleSuccessResponse } from '@services/useGetMyAccountSchedule';
import { CreateWorkerSuccessResponse } from '@services/useCreateWorker';
import { GetMyAccountServicesSuccessResponse } from '@services/useGetMyAccountServices';
import { GetMyAccountServiceDetailSuccessResponse } from '@services/useGetMyAccountServiceDetail';
import { CreateServiceSuccessResponse } from '@services/useCreateService';
import { GetStoreWorkersSuccessResponse } from '@services/useGetStoreWorkers';
import { GetAllCategoriesWithServicesSuccessResponse } from '@services/useGetAllCategoriesWithServices';
import { GetMCaesResponse } from '@services/useGetCaes';
import { GetZonesResponse } from '@services/useGetZones';
import { GetMyCouponsSuccessResponse } from '@services/useGetMyCoupons';
import { GetMyCouponDetailSuccessResponse } from '@services/useGetMyCouponDetail';
import { CreateCouponSuccessResponse } from '@services/useCreateCoupon';
import { GetServiceStoresSuccessResponse } from '@services/useGetServiceStores';
import { GetServicesToBookSuccessResponse } from '@services/useGetServicesToBook';
import { GetServicesCartTotalsSuccessResponse } from '@services/useGetServicesCartTotals';
import { GetAllStoreSchedulableWorkersSuccessResponse } from '@services/useGetAllStoreSchedulableWorkers';
import { CreateReservationsSuccessResponse } from '@services/useCreateReservations';
import { GetScheduleSuccessResponse } from '@services/useGetSchedule';
import { useEndpointState } from '@hooks/useEndpointState';
import { UserLocation } from '@types';
import { GetComplaintCategorySuccessResponse } from '@services/useGetComplaintCategories';
import { GetCampaignProductsSuccessResponse } from '@services/useGetCampaignProducts';
import { GetHighlightDetailSuccessResponse } from '@services/useGetHighlightDetail';
import { GetAllProductsSuccessResponse } from '@services/useGetAllProducts';
import { GetAllServicesSuccessResponse } from '@services/useGetAllServices';
import { GetMyAccountPointsHistorySuccessResponse } from '@services/useGetMyAccountPointsHistory';
import { GetMyAdherencesSuccessResponse } from '@services/useGetMyAdherences';
import { GetMyAdherenceDetailSuccessResponse } from '@services/useGetMyAdherenceDetail';
import { GetMyAccountDashboardIndicatorsSuccessResponse } from '@services/useGetMyAccountDashboardIndicators';
import { GetMyAccountDashboardChartsSuccessResponse } from '@services/useGetMyAccountDashboardCharts';
import { GetAllLockersSuccessResponse } from '@services/useGetAllLockers';
import { GetPointsFaqsSuccessResponse } from '@services/useGetPointsFaqs';
import { GetPointsServicesSuccessResponse } from '@services/useGetPointsServices';
import { GetAllCategoriesWithPointsServicesSuccessResponse } from '@services/useGetAllCategoriesWithPointsServices';
import { GetPointsServicesMaxPointsSuccessResponse } from '@services/useGetPointsServicesMaxPoints';
import { GetPointsServiceDetailSuccessResponse } from '@services/useGetPointsServiceDetail';
import { GetUserPointsSuccessResponse } from '@services/useGetUserPoints';
import { GetMyProductReservationsSuccessResponse } from '@services/useGetMyProductReservations';
import { GetMyProductReservationDetailSuccessResponse } from '@services/useGetMyProductReservationDetails';
import { GetMyStoresProductReservationDetailSuccessResponse } from '@services/useGetMyStoresProductReservationDetail';
import { GetMyStoresProductReservationsSuccessResponse } from '@services/useGetMyStoresProductReservations';

type EndpointsConfig = {
    [key: string]: {
        // if true, data will be stored/persisted on localStorage, and still be available if user refreshes the page
        // some endpoints don't need to be persisted (example: paginated product results)
        storeOnLocalStorage: boolean;

        // if storeOnLocalStorage is true, we can also set:

        // TTL (time-to-live) in milliseconds
        // if set, data will be cleared from localStorage after ttl
        ttl?: number | null;
        // if true, data will be cleared from localStorage after browser session changes
        // or when user logs in, or when user logs out
        clearOnNewSession?: boolean;
        // if true, data will be cleared from localStorage after user selects a different language
        clearOnLanguageChange?: boolean;
    };
};

const ENDPOINTS: EndpointsConfig = {
    login: {
        storeOnLocalStorage: true,
    },
    allProductsCategories: {
        storeOnLocalStorage: true,
        ttl: 600000, // 10 minutes
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    allCategoriesWithProducts: {
        storeOnLocalStorage: true,
        ttl: 600000, // 10 minutes
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    allCategoriesWithServices: {
        storeOnLocalStorage: true,
        ttl: 600000, // 10 minutes
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    allCategoriesWithPointsServices: {
        storeOnLocalStorage: true,
        ttl: 600000, // 10 minutes
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    productCategoryMaxPrice: {
        storeOnLocalStorage: false,
        ttl: null,
    },
    pointsServicesMaxPoints: {
        storeOnLocalStorage: false,
        ttl: null,
    },
    allServicesCategories: {
        storeOnLocalStorage: true,
        ttl: 600000, // 10 minutes
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    allProducts: {
        storeOnLocalStorage: false,
        ttl: null,
        clearOnLanguageChange: true,
    },
    products: {
        storeOnLocalStorage: false,
        ttl: null,
        clearOnLanguageChange: true,
    },
    campaignProducts: {
        storeOnLocalStorage: false,
        ttl: null,
        clearOnLanguageChange: true,
    },
    productDetail: {
        storeOnLocalStorage: false,
        ttl: null,
        clearOnLanguageChange: true,
    },
    pointsServiceDetail: {
        storeOnLocalStorage: false,
        ttl: null,
        clearOnLanguageChange: true,
    },
    highlightDetail: {
        storeOnLocalStorage: false,
        ttl: null,
        clearOnLanguageChange: true,
    },
    allLanguages: {
        storeOnLocalStorage: true,
        ttl: 600000, // 10 minutes
        clearOnNewSession: true,
    },
    allProductAttributesByCategory: {
        storeOnLocalStorage: false,
        ttl: null,
        clearOnLanguageChange: true,
    },
    allProductStores: {
        storeOnLocalStorage: true,
        ttl: 600000, // 10 minutes
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    allServiceStores: {
        storeOnLocalStorage: true,
        ttl: 600000, // 10 minutes
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    allSettings: {
        storeOnLocalStorage: true,
        ttl: 120000, // 2 minutes
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    allServices: {
        storeOnLocalStorage: false,
        ttl: null,
        clearOnLanguageChange: true,
    },
    serviceStores: {
        storeOnLocalStorage: false,
        ttl: null,
        clearOnLanguageChange: true,
    },
    allBundles: {
        storeOnLocalStorage: true,
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    campaignBundles: {
        storeOnLocalStorage: true,
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    campaigns: {
        storeOnLocalStorage: true,
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    bundleDetail: {
        storeOnLocalStorage: true,
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    allGeoDistricts: {
        storeOnLocalStorage: false,
        ttl: null,
    },
    allGeoMunicipalitiesOfDistrict: {
        storeOnLocalStorage: false,
        ttl: null,
    },
    allInstagramImages: {
        storeOnLocalStorage: true,
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    myPoints: {
        storeOnLocalStorage: true,
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    addresses: {
        storeOnLocalStorage: true,
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    addressesEdit: {
        storeOnLocalStorage: true,
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    addressesCreate: {
        storeOnLocalStorage: true,
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    addressesDetail: {
        storeOnLocalStorage: true,
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    stores: {
        storeOnLocalStorage: false,
        ttl: null,
        clearOnLanguageChange: true,
    },
    storesLocations: {
        storeOnLocalStorage: false,
        ttl: null,
    },
    allStoreWorkers: {
        storeOnLocalStorage: false,
        ttl: null,
    },
    allStoreSchedulableWorkers: {
        storeOnLocalStorage: false,
        ttl: null,
    },
    homepageStores: {
        storeOnLocalStorage: true,
        ttl: 1800000, //30 min
        clearOnLanguageChange: true,
    },
    storeDetail: {
        storeOnLocalStorage: false,
        ttl: null,
        clearOnLanguageChange: true,
    },
    servicesToBook: {
        storeOnLocalStorage: false,
        ttl: null,
        clearOnLanguageChange: true,
    },
    servicesCartTotals: {
        storeOnLocalStorage: false,
        ttl: null,
        clearOnLanguageChange: true,
    },
    allCarouselData: {
        storeOnLocalStorage: true,
        clearOnNewSession: true,
        clearOnLanguageChange: true,
    },
    cart: {
        storeOnLocalStorage: false,
        ttl: null,
    },
    storeSchedule: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    myAccountProducts: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
        clearOnLanguageChange: true,
    },
    myAccountDashboardIndicators: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    myAccountDashboardCharts: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    myAccountWorkers: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    myAccountStoreSchedule: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    myAccountServices: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
        clearOnLanguageChange: true,
    },
    myAccountServiceDetail: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
        clearOnLanguageChange: true,
    },
    myAccountProductDetail: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
        clearOnLanguageChange: true,
    },
    myAccountWorkerDetail: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    allMyAccountStores: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
        clearOnLanguageChange: true,
    },
    myAccountStoreDetail: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
        clearOnLanguageChange: true,
    },
    myAdherences: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    myAdherenceDetail: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    myCoupons: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    myCouponDetail: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    createdStore: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    createdProduct: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    createdReservations: {
        storeOnLocalStorage: true,
        clearOnNewSession: false,
        ttl: null,
    },
    createdCoupon: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    createdService: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    createdWorker: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    complaintCategories: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    user: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    userPoints: {
        storeOnLocalStorage: false,
        clearOnNewSession: false,
        ttl: null,
    },
    qrCode: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    cartItemDetail: {
        storeOnLocalStorage: false,
        ttl: null,
        clearOnLanguageChange: true,
    },
    allNearbyPickupSpots: {
        storeOnLocalStorage: false,
        ttl: null,
    },
    allLockers: {
        storeOnLocalStorage: false,
        ttl: null,
    },
    pickupSpotDetail: {
        storeOnLocalStorage: false,
        ttl: null,
    },
    allShippingCountries: {
        storeOnLocalStorage: true,
        ttl: 600000, // 10 minutes
        clearOnLanguageChange: true,
    },
    allPaymentMethods: {
        storeOnLocalStorage: true,
        ttl: null,
        clearOnLanguageChange: true,
    },
    createdOrder: {
        storeOnLocalStorage: true,
        clearOnNewSession: false,
        ttl: null,
    },
    myOrders: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    myOrderDetail: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    myStoresOrders: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    myStoresOrderDetail: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    myProductReservations: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    myProductReservationDetail: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    myStoresProductReservations: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    myStoresProductReservationDetail: {
        storeOnLocalStorage: false,
        clearOnNewSession: true,
        ttl: null,
    },
    allCaes: {
        storeOnLocalStorage: false,
        ttl: null,
    },
    allZones: {
        storeOnLocalStorage: false,
        ttl: null,
    },
    lastUserLocationLogged: {
        storeOnLocalStorage: false,
        ttl: null,
    },
    cancelLockerCompartmentReservation: {
        storeOnLocalStorage: false,
        ttl: null,
    },
    pointsFaqs: {
        storeOnLocalStorage: false,
        ttl: 120000, // 2 minutes
    },
    pointsServices: {
        storeOnLocalStorage: false,
        ttl: 120000, // 2 minutes
    },
};

export type DataContextProps = {
    login: LoginSuccessResponse | null;
    setLogin: (data: LoginSuccessResponse | null) => void;

    allProductsCategories: GetAllProductsCategoriesSuccessResponse | null;
    setAllProductsCategories: (data: GetAllProductsCategoriesSuccessResponse) => void;
    isLoadingAllProductsCategories: boolean;
    setIsLoadingAllProductsCategories: (value: boolean) => void;

    allCategoriesWithServices: GetAllCategoriesWithServicesSuccessResponse | null;
    setAllCategoriesWithServices: (data: GetAllCategoriesWithServicesSuccessResponse) => void;
    isLoadingAllCategoriesWithServices: boolean;
    setIsLoadingAllCategoriesWithServices: (value: boolean) => void;

    allCategoriesWithProducts: GetAllCategoriesWithProductsSuccessResponse | null;
    setAllCategoriesWithProducts: (data: GetAllCategoriesWithProductsSuccessResponse) => void;
    isLoadingAllCategoriesWithProducts: boolean;
    setIsLoadingAllCategoriesWithProducts: (value: boolean) => void;

    allCategoriesWithPointsServices: GetAllCategoriesWithPointsServicesSuccessResponse | null;
    setAllCategoriesWithPointsServices: (data: GetAllCategoriesWithPointsServicesSuccessResponse) => void;
    isLoadingAllCategoriesWithPointsServices: boolean;
    setIsLoadingAllCategoriesWithPointsServices: (value: boolean) => void;

    productCategoryMaxPrice: GetProductCategoryMaxPriceSuccessResponse | null;
    setProductCategoryMaxPrice: (data: GetProductCategoryMaxPriceSuccessResponse) => void;

    pointsServicesMaxPoints: GetPointsServicesMaxPointsSuccessResponse | null;
    setPointsServicesMaxPoints: (data: GetPointsServicesMaxPointsSuccessResponse) => void;

    allServicesCategories: GetAllServicesCategoriesSuccessResponse | null;
    setAllServicesCategories: (data: GetAllServicesCategoriesSuccessResponse) => void;
    isLoadingAllServicesCategories: boolean;
    setIsLoadingAllServicesCategories: (value: boolean) => void;

    allLanguages: GetAllLanguagesSuccessResponse | null;
    setAllLanguages: (data: GetAllLanguagesSuccessResponse) => void;

    allProducts: GetAllProductsSuccessResponse | null;
    setAllProducts: (data: GetAllProductsSuccessResponse | null) => void;
    isLoadingAllProducts: boolean;
    setIsLoadingAllProducts: (value: boolean) => void;

    products: GetProductsSuccessResponse | null;
    setProducts: (data: GetProductsSuccessResponse | null) => void;
    isLoadingProducts: boolean;
    setIsLoadingProducts: (value: boolean) => void;

    campaignProducts: GetCampaignProductsSuccessResponse | null;
    setCampaignProducts: (data: GetCampaignProductsSuccessResponse | null) => void;
    isLoadingCampaignProducts: boolean;
    setIsLoadingCampaignProducts: (value: boolean) => void;

    productDetail: GetProductDetailSuccessResponse | null;
    setProductDetail: (data: GetProductDetailSuccessResponse) => void;

    pointsServiceDetail: GetPointsServiceDetailSuccessResponse | null;
    setPointsServiceDetail: (data: GetPointsServiceDetailSuccessResponse) => void;

    highlightDetail: GetHighlightDetailSuccessResponse | null;
    setHighlightDetail: (data: GetHighlightDetailSuccessResponse) => void;

    allProductAttributesByCategory: GetAllProductAttributesByCategorySuccessResponse | null;
    setAllProductAttributesByCategory: (data: GetAllProductAttributesByCategorySuccessResponse) => void;

    allProductStores: GetAllProductStoresSuccessResponse | null;
    setAllProductStores: (data: GetAllProductStoresSuccessResponse) => void;
    isLoadingAllProductStores: boolean;
    setIsLoadingAllProductStores: (value: boolean) => void;

    allServiceStores: GetAllServiceStoresSuccessResponse | null;
    setAllServiceStores: (data: GetAllServiceStoresSuccessResponse) => void;

    allSettings: GetAllSettingsSuccessResponse | null;
    setAllSettings: (data: GetAllSettingsSuccessResponse) => void;

    allBundles: GetAllBundlesSuccessResponse | null;
    setAllBundles: (data: GetAllBundlesSuccessResponse) => void;

    campaignBundles: GetCampaignBundlesSuccessResponse | null;
    setCampaignBundles: (data: GetCampaignBundlesSuccessResponse) => void;

    campaigns: GetCampaignsSuccessResponse | null;
    setCampaigns: (data: GetCampaignsSuccessResponse) => void;

    bundleDetail: GetBundleDetailSuccessResponse | null;
    setBundleDetail: (data: GetBundleDetailSuccessResponse) => void;

    allInstagramImages: GetAllInstagramImagesSuccessResponse | null;
    setAllInstagramImages: (data: GetAllInstagramImagesSuccessResponse) => void;

    stores: GetStoresSuccessResponse | null;
    setStores: (data: GetStoresSuccessResponse | null) => void;
    isLoadingStores: boolean;
    setIsLoadingStores: (value: boolean) => void;

    homepageStores: GetHomepageStoresSuccessResponse | null;
    setHomepageStores: (data: GetHomepageStoresSuccessResponse | null) => void;
    isLoadingHomepageStores: boolean;
    setIsLoadingHomepageStores: (value: boolean) => void;

    allStoreWorkers: GetStoreWorkersSuccessResponse | null;
    setAllStoreWorkers: (data: GetStoreWorkersSuccessResponse | null) => void;

    allStoreSchedulableWorkers: GetAllStoreSchedulableWorkersSuccessResponse | null;
    setAllStoreSchedulableWorkers: (data: GetAllStoreSchedulableWorkersSuccessResponse | null) => void;

    storesLocations: GetStoresLocationSuccessResponse | null;
    setStoresLocations: (data: GetStoresLocationSuccessResponse | null) => void;
    isLoadingStoresLocations: boolean;
    setIsLoadingStoresLocations: (value: boolean) => void;

    storeDetail: GetStoreDetailSuccessResponse | null;
    setStoreDetail: (data: GetStoreDetailSuccessResponse | null) => void;
    isLoadingStoreDetail: boolean;
    setIsLoadingStoreDetail: (value: boolean) => void;

    servicesToBook: GetServicesToBookSuccessResponse | null;
    setServicesToBook: (data: GetServicesToBookSuccessResponse | null) => void;
    isLoadingServicesToBook: boolean;
    setIsLoadingServicesToBook: (value: boolean) => void;

    servicesCartTotals: GetServicesCartTotalsSuccessResponse | null;
    setServicesCartTotals: (data: GetServicesCartTotalsSuccessResponse | null) => void;
    isLoadingServicesCartTotals: boolean;
    setIsLoadingServicesCartTotals: (value: boolean) => void;

    allGeoDistricts: GetAllGeoDistrictsSuccessResponse | null;
    setAllGeoDistricts: (data: GetAllGeoDistrictsSuccessResponse) => void;

    allGeoMunicipalitiesOfDistrict: GetAllGeoMunicipalitiesOfDistrictSuccessResponse | null;
    setAllGeoMunicipalitiesOfDistrict: (data: GetAllGeoMunicipalitiesOfDistrictSuccessResponse) => void;

    allCarouselData: GetAllCarouselDataSuccessResponse | null;
    setAllCarouselData: (data: GetAllCarouselDataSuccessResponse) => void;

    allServices: GetAllServicesSuccessResponse | null;
    setAllServices: (data: GetAllServicesSuccessResponse | null) => void;
    isLoadingAllServices: boolean;
    setIsLoadingAllServices: (value: boolean) => void;

    serviceStores: GetServiceStoresSuccessResponse | null;
    setServiceStores: (data: GetServiceStoresSuccessResponse | null) => void;
    isLoadingServiceStores: boolean;
    setIsLoadingServiceStores: (value: boolean) => void;

    myPoints: GetMyAccountPointsHistorySuccessResponse | null;
    setMyPoints: (data: GetMyAccountPointsHistorySuccessResponse) => void;

    addresses: GetAddressesSuccessResponse | null;
    setAddresses: (data: GetAddressesSuccessResponse) => void;

    addressesEdit: GetMyAccountAddressesEditSuccessResponse | null;
    setAddressesEdit: (data: GetMyAccountAddressesEditSuccessResponse) => void;
    isLoadingAddressesEdit: boolean;
    setIsLoadingAddressesEdit: (value: boolean) => void;

    addressesCreate: GetMyAccountAddressesCreateSuccessResponse | null;
    setAddressesCreate: (data: GetMyAccountAddressesCreateSuccessResponse) => void;

    addressesDetail: GetMyAccountAddressesDetailSuccessResponse | null;
    setAddressesDetail: (data: GetMyAccountAddressesDetailSuccessResponse | null) => void;
    isLoadingAddressesDetail: boolean;
    setIsLoadingAddressesDetail: (value: boolean) => void;

    cart: GetCartSuccessResponse | null;
    setCart: (data: GetCartSuccessResponse | null) => void;

    storeSchedule: GetScheduleSuccessResponse | null;
    setStoreSchedule: (data: GetScheduleSuccessResponse | null) => void;
    isLoadingStoreSchedule: boolean;
    setIsLoadingStoreSchedule: (value: boolean) => void;

    myAccountProducts: GetMyAccountProductsSuccessResponse | null;
    setMyAccountProducts: (data: GetMyAccountProductsSuccessResponse | null) => void;
    isLoadingMyAccountProducts: boolean;
    setIsLoadingMyAccountProducts: (value: boolean) => void;

    myAccountDashboardIndicators: GetMyAccountDashboardIndicatorsSuccessResponse | null;
    setMyAccountDashboardIndicators: (data: GetMyAccountDashboardIndicatorsSuccessResponse | null) => void;
    isLoadingMyAccountDashboardIndicators: boolean;
    setIsLoadingMyAccountDashboardIndicators: (value: boolean) => void;

    myAccountDashboardCharts: GetMyAccountDashboardChartsSuccessResponse | null;
    setMyAccountDashboardCharts: (data: GetMyAccountDashboardChartsSuccessResponse | null) => void;
    isLoadingMyAccountDashboardCharts: boolean;
    setIsLoadingMyAccountDashboardCharts: (value: boolean) => void;

    myAccountWorkers: GetMyAccountWorkersSuccessResponse | null;
    setMyAccountWorkers: (data: GetMyAccountWorkersSuccessResponse | null) => void;
    isLoadingMyAccountWorkers: boolean;
    setIsLoadingMyAccountWorkers: (value: boolean) => void;

    myAccountStoreSchedule: GetMyAccountScheduleSuccessResponse | null;
    setMyAccountStoreSchedule: (data: GetMyAccountScheduleSuccessResponse | null) => void;
    isLoadingMyAccountStoreSchedule: boolean;
    setIsLoadingMyAccountStoreSchedule: (value: boolean) => void;

    myAccountServices: GetMyAccountServicesSuccessResponse | null;
    setMyAccountServices: (data: GetMyAccountServicesSuccessResponse | null) => void;
    isLoadingMyAccountServices: boolean;
    setIsLoadingMyAccountServices: (value: boolean) => void;

    myAccountServiceDetail: GetMyAccountServiceDetailSuccessResponse | null;
    setMyAccountServiceDetail: (data: GetMyAccountServiceDetailSuccessResponse | null) => void;
    isLoadingMyAccountServiceDetail: boolean;
    setIsLoadingMyAccountServiceDetail: (value: boolean) => void;

    myAccountProductDetail: GetMyAccountProductDetailSuccessResponse | null;
    setMyAccountProductDetail: (data: GetMyAccountProductDetailSuccessResponse | null) => void;
    isLoadingMyAccountProductDetail: boolean;
    setIsLoadingMyAccountProductDetail: (value: boolean) => void;

    myAccountWorkerDetail: GetMyAccountWorkerDetailSuccessResponse | null;
    setMyAccountWorkerDetail: (data: GetMyAccountWorkerDetailSuccessResponse | null) => void;
    isLoadingMyAccountWorkerDetail: boolean;
    setIsLoadingMyAccountWorkerDetail: (value: boolean) => void;

    allMyAccountStores: GetAllMyAccountStoresSuccessResponse | null;
    setAllMyAccountStores: (data: GetAllMyAccountStoresSuccessResponse | null) => void;
    isLoadingAllMyAccountStores: boolean;
    setIsLoadingAllMyAccountStores: (value: boolean) => void;

    myAccountStoreDetail: GetMyAccountStoreDetailSuccessResponse | null;
    setMyAccountStoreDetail: (data: GetMyAccountStoreDetailSuccessResponse | null) => void;
    isLoadingMyAccountStoreDetail: boolean;
    setIsLoadingMyAccountStoreDetail: (value: boolean) => void;

    myAdherences: GetMyAdherencesSuccessResponse | null;
    setMyAdherences: (data: GetMyAdherencesSuccessResponse | null) => void;
    isLoadingMyAdherences: boolean;
    setIsLoadingMyAdherences: (value: boolean) => void;

    myAdherenceDetail: GetMyAdherenceDetailSuccessResponse | null;
    setMyAdherenceDetail: (data: GetMyAdherenceDetailSuccessResponse | null) => void;
    isLoadingMyAdherenceDetail: boolean;
    setIsLoadingMyAdherenceDetail: (value: boolean) => void;

    myCoupons: GetMyCouponsSuccessResponse | null;
    setMyCoupons: (data: GetMyCouponsSuccessResponse | null) => void;
    isLoadingMyCoupons: boolean;
    setIsLoadingMyCoupons: (value: boolean) => void;

    myCouponDetail: GetMyCouponDetailSuccessResponse | null;
    setMyCouponDetail: (data: GetMyCouponDetailSuccessResponse | null) => void;
    isLoadingMyCouponDetail: boolean;
    setIsLoadingMyCouponDetail: (value: boolean) => void;

    createdStore: CreateStoreSuccessResponse | null;
    setCreatedStore: (data: CreateStoreSuccessResponse | null) => void;

    createdProduct: CreateProductSuccessResponse | null;
    setCreatedProduct: (data: CreateProductSuccessResponse | null) => void;

    createdReservations: CreateReservationsSuccessResponse | null;
    setCreatedReservations: (data: CreateReservationsSuccessResponse | null) => void;

    createdCoupon: CreateCouponSuccessResponse | null;
    setCreatedCoupon: (data: CreateCouponSuccessResponse | null) => void;

    createdService: CreateServiceSuccessResponse | null;
    setCreatedService: (data: CreateServiceSuccessResponse | null) => void;

    createdWorker: CreateWorkerSuccessResponse | null;
    setCreatedWorker: (data: CreateWorkerSuccessResponse | null) => void;

    complaintCategories: GetComplaintCategorySuccessResponse | null;
    setComplaintCategories: (data: GetComplaintCategorySuccessResponse | null) => void;

    user: GetUserSuccessResponse | null;
    setUser: (data: GetUserSuccessResponse | null) => void;
    isLoadingUser: boolean;
    setIsLoadingUser: (value: boolean) => void;

    userPoints: GetUserPointsSuccessResponse | null;
    setUserPoints: (data: GetUserPointsSuccessResponse | null) => void;

    qrCode: google2FAQrCodeSuccessResponse | null;
    setQrCode: (data: google2FAQrCodeSuccessResponse | null) => void;

    cartItemDetail: GetCartItemDetailSuccessResponse | null;
    setCartItemDetail: (data: GetCartItemDetailSuccessResponse) => void;

    allNearbyPickupSpots: GetAllNearbyPickupSpotsSuccessResponse | null;
    setAllNearbyPickupSpots: (data: GetAllNearbyPickupSpotsSuccessResponse | null) => void;

    allLockers: GetAllLockersSuccessResponse | null;
    setAllLockers: (data: GetAllLockersSuccessResponse | null) => void;

    pickupSpotDetail: GetPickupSpotDetailSuccessResponse | null;
    setPickupSpotDetail: (data: GetPickupSpotDetailSuccessResponse | null) => void;

    allShippingCountries: GetAllShippingCountriesSuccessResponse | null;
    setAllShippingCountries: (data: GetAllShippingCountriesSuccessResponse | null) => void;

    allPaymentMethods: GetAllPaymentMethodsSuccessResponse | null;
    setAllPaymentMethods: (data: GetAllPaymentMethodsSuccessResponse | null) => void;
    isLoadingAllPaymentMethods: boolean;
    setIsLoadingAllPaymentMethods: (value: boolean) => void;

    createdOrder: CreateOrderSuccessResponse | null;
    setCreatedOrder: (data: CreateOrderSuccessResponse | null) => void;

    myOrders: GetMyOrdersSuccessResponse | null;
    setMyOrders: (data: GetMyOrdersSuccessResponse | null) => void;
    isLoadingMyOrders: boolean;
    setIsLoadingMyOrders: (value: boolean) => void;

    myOrderDetail: GetMyOrderDetailSuccessResponse | null;
    setMyOrderDetail: (data: GetMyOrderDetailSuccessResponse | null) => void;
    isLoadingMyOrderDetail: boolean;
    setIsLoadingMyOrderDetail: (value: boolean) => void;

    myStoresOrders: GetMyStoresOrdersSuccessResponse | null;
    setMyStoresOrders: (data: GetMyStoresOrdersSuccessResponse | null) => void;
    isLoadingMyStoresOrders: boolean;
    setIsLoadingMyStoresOrders: (value: boolean) => void;

    myStoresOrderDetail: GetMyStoresOrderDetailSuccessResponse | null;
    setMyStoresOrderDetail: (data: GetMyStoresOrderDetailSuccessResponse | null) => void;
    isLoadingMyStoresOrderDetail: boolean;
    setIsLoadingMyStoresOrderDetail: (value: boolean) => void;

    myProductReservations: GetMyProductReservationsSuccessResponse | null;
    setMyProductReservations: (data: GetMyProductReservationsSuccessResponse | null) => void;
    isLoadingMyProductReservations: boolean;
    setIsLoadingMyProductReservations: (value: boolean) => void;

    myProductReservationDetail: GetMyProductReservationDetailSuccessResponse | null;
    setMyProductReservationDetail: (data: GetMyProductReservationDetailSuccessResponse | null) => void;
    isLoadingMyProductReservationDetail: boolean;
    setIsLoadingMyProductReservationDetail: (value: boolean) => void;

    myStoresProductReservations: GetMyStoresProductReservationsSuccessResponse | null;
    setMyStoresProductReservations: (data: GetMyStoresProductReservationsSuccessResponse | null) => void;
    isLoadingMyStoresProductReservations: boolean;
    setIsLoadingMyStoresProductReservations: (value: boolean) => void;

    myStoresProductReservationDetail: GetMyStoresProductReservationDetailSuccessResponse | null;
    setMyStoresProductReservationDetail: (data: GetMyStoresProductReservationDetailSuccessResponse | null) => void;
    isLoadingMyStoresProductReservationDetail: boolean;
    setIsLoadingMyStoresProductReservationDetail: (value: boolean) => void;

    allCaes: GetMCaesResponse | null;
    setAllCaes: (data: GetMCaesResponse | null) => void;
    isLoadingAllCaes: boolean;
    setIsLoadingAllCaes: (value: boolean) => void;

    allZones: GetZonesResponse | null;
    setAllZones: (data: GetZonesResponse | null) => void;
    isLoadingAllZones: boolean;
    setIsLoadingAllZones: (value: boolean) => void;

    lastUserLocationLogged: UserLocation | null;
    setLastUserLocationLogged: (data: UserLocation | null) => void;

    isLoadingCancelLockerCompartmentReservation: boolean;
    setIsLoadingCancelLockerCompartmentReservation: (value: boolean) => void;

    pointsFaqs: GetPointsFaqsSuccessResponse | null;
    setPointsFaqs: (data: GetPointsFaqsSuccessResponse | null) => void;

    pointsServices: GetPointsServicesSuccessResponse | null;
    setPointsServices: (data: GetPointsServicesSuccessResponse | null) => void;
    isLoadingPointsServices: boolean;
    setIsLoadingPointsServices: (value: boolean) => void;
};

/**
 * DataContext acts as a data center for information retrieved from fetching endpoints.
 */
export const DataContext = createContext<DataContextProps>({
    // null values mean the service has yet to be called successfully

    login: null,
    setLogin: () => {},

    allProductsCategories: null,
    setAllProductsCategories: () => {},
    isLoadingAllProductsCategories: false,
    setIsLoadingAllProductsCategories: () => {},

    allCategoriesWithServices: null,
    setAllCategoriesWithServices: () => {},
    isLoadingAllCategoriesWithServices: false,
    setIsLoadingAllCategoriesWithServices: () => {},

    allCategoriesWithProducts: null,
    setAllCategoriesWithProducts: () => {},
    isLoadingAllCategoriesWithProducts: false,
    setIsLoadingAllCategoriesWithProducts: () => {},

    allCategoriesWithPointsServices: null,
    setAllCategoriesWithPointsServices: () => {},
    isLoadingAllCategoriesWithPointsServices: false,
    setIsLoadingAllCategoriesWithPointsServices: () => {},

    productCategoryMaxPrice: null,
    setProductCategoryMaxPrice: () => {},

    pointsServicesMaxPoints: null,
    setPointsServicesMaxPoints: () => {},

    allServicesCategories: null,
    setAllServicesCategories: () => {},
    isLoadingAllServicesCategories: false,
    setIsLoadingAllServicesCategories: () => {},

    allLanguages: null,
    setAllLanguages: () => {},

    allProducts: null,
    setAllProducts: () => {},
    isLoadingAllProducts: false,
    setIsLoadingAllProducts: () => {},

    products: null,
    setProducts: () => {},
    isLoadingProducts: false,
    setIsLoadingProducts: () => {},

    campaignProducts: null,
    setCampaignProducts: () => {},
    isLoadingCampaignProducts: false,
    setIsLoadingCampaignProducts: () => {},

    productDetail: null,
    setProductDetail: () => {},

    pointsServiceDetail: null,
    setPointsServiceDetail: () => {},

    highlightDetail: null,
    setHighlightDetail: () => {},

    allProductAttributesByCategory: null,
    setAllProductAttributesByCategory: () => {},

    allProductStores: null,
    setAllProductStores: () => {},
    isLoadingAllProductStores: false,
    setIsLoadingAllProductStores: () => {},

    allServiceStores: null,
    setAllServiceStores: () => {},

    allSettings: null,
    setAllSettings: () => {},

    allInstagramImages: null,
    setAllInstagramImages: () => {},

    allBundles: null,
    setAllBundles: () => {},

    campaignBundles: null,
    setCampaignBundles: () => {},

    campaigns: null,
    setCampaigns: () => {},

    bundleDetail: null,
    setBundleDetail: () => {},

    stores: null,
    setStores: () => {},
    isLoadingStores: false,
    setIsLoadingStores: () => {},

    homepageStores: null,
    setHomepageStores: () => {},
    isLoadingHomepageStores: false,
    setIsLoadingHomepageStores: () => {},

    allStoreWorkers: null,
    setAllStoreWorkers: () => {},

    allStoreSchedulableWorkers: null,
    setAllStoreSchedulableWorkers: () => {},

    storesLocations: null,
    setStoresLocations: () => {},
    isLoadingStoresLocations: false,
    setIsLoadingStoresLocations: () => {},

    storeDetail: null,
    setStoreDetail: () => {},
    isLoadingStoreDetail: false,
    setIsLoadingStoreDetail: () => {},

    servicesToBook: null,
    setServicesToBook: () => {},
    isLoadingServicesToBook: false,
    setIsLoadingServicesToBook: () => {},

    servicesCartTotals: null,
    setServicesCartTotals: () => {},
    isLoadingServicesCartTotals: false,
    setIsLoadingServicesCartTotals: () => {},

    allGeoDistricts: null,
    setAllGeoDistricts: () => {},

    allGeoMunicipalitiesOfDistrict: null,
    setAllGeoMunicipalitiesOfDistrict: () => {},

    allCarouselData: null,
    setAllCarouselData: () => {},

    allServices: null,
    setAllServices: () => {},
    isLoadingAllServices: false,
    setIsLoadingAllServices: () => {},

    serviceStores: null,
    setServiceStores: () => {},
    isLoadingServiceStores: false,
    setIsLoadingServiceStores: () => {},

    myPoints: null,
    setMyPoints: () => {},

    addresses: null,
    setAddresses: () => {},

    addressesEdit: null,
    setAddressesEdit: () => {},
    isLoadingAddressesEdit: false,
    setIsLoadingAddressesEdit: () => {},

    addressesCreate: null,
    setAddressesCreate: () => {},

    addressesDetail: null,
    setAddressesDetail: () => {},
    isLoadingAddressesDetail: false,
    setIsLoadingAddressesDetail: () => {},

    cart: null,
    setCart: () => {},

    storeSchedule: null,
    setStoreSchedule: () => {},
    isLoadingStoreSchedule: false,
    setIsLoadingStoreSchedule: () => {},

    myAccountProducts: null,
    setMyAccountProducts: () => {},
    isLoadingMyAccountProducts: false,
    setIsLoadingMyAccountProducts: () => {},

    myAccountDashboardIndicators: null,
    setMyAccountDashboardIndicators: () => {},
    isLoadingMyAccountDashboardIndicators: false,
    setIsLoadingMyAccountDashboardIndicators: () => {},

    myAccountDashboardCharts: null,
    setMyAccountDashboardCharts: () => {},
    isLoadingMyAccountDashboardCharts: false,
    setIsLoadingMyAccountDashboardCharts: () => {},

    myAccountWorkers: null,
    setMyAccountWorkers: () => {},
    isLoadingMyAccountWorkers: false,
    setIsLoadingMyAccountWorkers: () => {},

    myAccountStoreSchedule: null,
    setMyAccountStoreSchedule: () => {},
    isLoadingMyAccountStoreSchedule: false,
    setIsLoadingMyAccountStoreSchedule: () => {},

    myAccountServices: null,
    setMyAccountServices: () => {},
    isLoadingMyAccountServices: false,
    setIsLoadingMyAccountServices: () => {},

    myAccountServiceDetail: null,
    setMyAccountServiceDetail: () => {},
    isLoadingMyAccountServiceDetail: false,
    setIsLoadingMyAccountServiceDetail: () => {},

    myAccountProductDetail: null,
    setMyAccountProductDetail: () => {},
    isLoadingMyAccountProductDetail: false,
    setIsLoadingMyAccountProductDetail: () => {},

    myAccountWorkerDetail: null,
    setMyAccountWorkerDetail: () => {},
    isLoadingMyAccountWorkerDetail: false,
    setIsLoadingMyAccountWorkerDetail: () => {},

    allMyAccountStores: null,
    setAllMyAccountStores: () => {},
    isLoadingAllMyAccountStores: false,
    setIsLoadingAllMyAccountStores: () => {},

    myAccountStoreDetail: null,
    setMyAccountStoreDetail: () => {},
    isLoadingMyAccountStoreDetail: false,
    setIsLoadingMyAccountStoreDetail: () => {},

    myAdherences: null,
    setMyAdherences: () => {},
    isLoadingMyAdherences: false,
    setIsLoadingMyAdherences: () => {},

    myAdherenceDetail: null,
    setMyAdherenceDetail: () => {},
    isLoadingMyAdherenceDetail: false,
    setIsLoadingMyAdherenceDetail: () => {},

    myCoupons: null,
    setMyCoupons: () => {},
    isLoadingMyCoupons: false,
    setIsLoadingMyCoupons: () => {},

    myCouponDetail: null,
    setMyCouponDetail: () => {},
    isLoadingMyCouponDetail: false,
    setIsLoadingMyCouponDetail: () => {},

    createdStore: null,
    setCreatedStore: () => {},

    createdProduct: null,
    setCreatedProduct: () => {},

    createdReservations: null,
    setCreatedReservations: () => {},

    createdCoupon: null,
    setCreatedCoupon: () => {},

    createdService: null,
    setCreatedService: () => {},

    createdWorker: null,
    setCreatedWorker: () => {},

    complaintCategories: null,
    setComplaintCategories: () => {},

    user: null,
    setUser: () => {},
    isLoadingUser: false,
    setIsLoadingUser: () => {},

    userPoints: null,
    setUserPoints: () => {},

    qrCode: null,
    setQrCode: () => {},

    cartItemDetail: null,
    setCartItemDetail: () => {},

    allNearbyPickupSpots: null,
    setAllNearbyPickupSpots: () => {},

    allLockers: null,
    setAllLockers: () => {},

    pickupSpotDetail: null,
    setPickupSpotDetail: () => {},

    allShippingCountries: null,
    setAllShippingCountries: () => {},

    allPaymentMethods: null,
    setAllPaymentMethods: () => {},
    isLoadingAllPaymentMethods: false,
    setIsLoadingAllPaymentMethods: () => {},

    createdOrder: null,
    setCreatedOrder: () => {},

    myOrders: null,
    setMyOrders: () => {},
    isLoadingMyOrders: false,
    setIsLoadingMyOrders: () => {},

    myOrderDetail: null,
    setMyOrderDetail: () => {},
    isLoadingMyOrderDetail: false,
    setIsLoadingMyOrderDetail: () => {},

    myStoresOrders: null,
    setMyStoresOrders: () => {},
    isLoadingMyStoresOrders: false,
    setIsLoadingMyStoresOrders: () => {},

    myStoresOrderDetail: null,
    setMyStoresOrderDetail: () => {},
    isLoadingMyStoresOrderDetail: false,
    setIsLoadingMyStoresOrderDetail: () => {},

    myProductReservations: null,
    setMyProductReservations: () => {},
    isLoadingMyProductReservations: false,
    setIsLoadingMyProductReservations: () => {},

    myProductReservationDetail: null,
    setMyProductReservationDetail: () => {},
    isLoadingMyProductReservationDetail: false,
    setIsLoadingMyProductReservationDetail: () => {},

    myStoresProductReservations: null,
    setMyStoresProductReservations: () => {},
    isLoadingMyStoresProductReservations: false,
    setIsLoadingMyStoresProductReservations: () => {},

    myStoresProductReservationDetail: null,
    setMyStoresProductReservationDetail: () => {},
    isLoadingMyStoresProductReservationDetail: false,
    setIsLoadingMyStoresProductReservationDetail: () => {},

    allCaes: null,
    setAllCaes: () => {},
    isLoadingAllCaes: false,
    setIsLoadingAllCaes: () => {},

    allZones: null,
    setAllZones: () => {},
    isLoadingAllZones: false,
    setIsLoadingAllZones: () => {},

    lastUserLocationLogged: null,
    setLastUserLocationLogged: () => {},

    isLoadingCancelLockerCompartmentReservation: false,
    setIsLoadingCancelLockerCompartmentReservation: () => {},

    pointsFaqs: null,
    setPointsFaqs: () => {},

    pointsServices: null,
    setPointsServices: () => {},
    isLoadingPointsServices: false,
    setIsLoadingPointsServices: () => {},
});

type DataContextProvider = {
    children: ReactNode;
};

export const DataProvider: FC<DataContextProvider> = ({ children }) => {
    const { setEndpointState, getEndpointState } = useEndpointState(ENDPOINTS);

    const { data: login } = getEndpointState('login');
    const { data: allProductsCategories, loading: isLoadingAllProductsCategories } = getEndpointState('allProductsCategories');
    const { data: allCategoriesWithProducts, loading: isLoadingAllCategoriesWithProducts } =
        getEndpointState('allCategoriesWithProducts');
    const { data: allCategoriesWithServices, loading: isLoadingAllCategoriesWithServices } =
        getEndpointState('allCategoriesWithServices');
    const { data: allCategoriesWithPointsServices, loading: isLoadingAllCategoriesWithPointsServices } = getEndpointState(
        'allCategoriesWithPointsServices'
    );
    const { data: productCategoryMaxPrice } = getEndpointState('productCategoryMaxPrice');
    const { data: pointsServicesMaxPoints } = getEndpointState('pointsServicesMaxPoints');
    const { data: allServicesCategories, loading: isLoadingAllServicesCategories } = getEndpointState('allServicesCategories');
    const { data: allLanguages } = getEndpointState('allLanguages');
    const { data: campaignProducts, loading: isLoadingCampaignProducts } = getEndpointState('campaignProducts');
    const { data: allProducts, loading: isLoadingAllProducts } = getEndpointState('allProducts');
    const { data: products, loading: isLoadingProducts } = getEndpointState('products');
    const { data: productDetail } = getEndpointState('productDetail');
    const { data: pointsServiceDetail } = getEndpointState('pointsServiceDetail');
    const { data: highlightDetail } = getEndpointState('highlightDetail');
    const { data: allProductAttributesByCategory } = getEndpointState('allProductAttributesByCategory');
    const { data: allProductStores, loading: isLoadingAllProductStores } = getEndpointState('allProductStores');
    const { data: allServiceStores } = getEndpointState('allServiceStores');
    const { data: allSettings } = getEndpointState('allSettings');
    const { data: allInstagramImages } = getEndpointState('allInstagramImages');
    const { data: allBundles } = getEndpointState('allBundles');
    const { data: bundleDetail } = getEndpointState('bundleDetail');
    const { data: campaignBundles } = getEndpointState('campaignBundles');
    const { data: campaigns } = getEndpointState('campaigns');
    const { data: stores, loading: isLoadingStores } = getEndpointState('stores');
    const { data: homepageStores, loading: isLoadingHomepageStores } = getEndpointState('homepageStores');
    const { data: storesLocations, loading: isLoadingStoresLocations } = getEndpointState('storesLocations');
    const { data: allStoreWorkers } = getEndpointState('allStoreWorkers');
    const { data: allStoreSchedulableWorkers } = getEndpointState('allStoreSchedulableWorkers');
    const { data: storeDetail, loading: isLoadingStoreDetail } = getEndpointState('storeDetail');
    const { data: servicesToBook, loading: isLoadingServicesToBook } = getEndpointState('servicesToBook');
    const { data: servicesCartTotals, loading: isLoadingServicesCartTotals } = getEndpointState('servicesCartTotals');
    const { data: allGeoDistricts } = getEndpointState('allGeoDistricts');
    const { data: allGeoMunicipalitiesOfDistrict } = getEndpointState('allGeoMunicipalitiesOfDistrict');
    const { data: allCarouselData } = getEndpointState('allCarouselData');
    const { data: allServices, loading: isLoadingAllServices } = getEndpointState('allServices');
    const { data: serviceStores, loading: isLoadingServiceStores } = getEndpointState('serviceStores');
    const { data: myPoints } = getEndpointState('myPoints');
    const { data: addresses } = getEndpointState('addresses');
    const { data: addressesEdit, loading: isLoadingAddressesEdit } = getEndpointState('addressesEdit');
    const { data: addressesCreate } = getEndpointState('addressesCreate');
    const { data: addressesDetail } = getEndpointState('addressesDetail');
    const { data: cart } = getEndpointState('cart');
    const { data: storeSchedule, loading: isLoadingStoreSchedule } = getEndpointState('storeSchedule');
    const { data: myAccountProducts, loading: isLoadingMyAccountProducts } = getEndpointState('myAccountProducts');
    const { data: myAccountDashboardIndicators, loading: isLoadingMyAccountDashboardIndicators } =
        getEndpointState('myAccountDashboardIndicators');
    const { data: myAccountDashboardCharts, loading: isLoadingMyAccountDashboardCharts } =
        getEndpointState('myAccountDashboardCharts');
    const { data: myAccountWorkers, loading: isLoadingMyAccountWorkers } = getEndpointState('myAccountWorkers');
    const { data: myAccountStoreSchedule, loading: isLoadingMyAccountStoreSchedule } = getEndpointState('myAccountStoreSchedule');
    const { data: myAccountServices, loading: isLoadingMyAccountServices } = getEndpointState('myAccountServices');
    const { data: myAccountServiceDetail, loading: isLoadingMyAccountServiceDetail } = getEndpointState('myAccountServiceDetail');
    const { data: myAccountProductDetail, loading: isLoadingMyAccountProductDetail } = getEndpointState('myAccountProductDetail');
    const { data: myAccountWorkerDetail, loading: isLoadingMyAccountWorkerDetail } = getEndpointState('myAccountWorkerDetail');
    const { data: allMyAccountStores, loading: isLoadingAllMyAccountStores } = getEndpointState('allMyAccountStores');
    const { data: myAccountStoreDetail, loading: isLoadingMyAccountStoreDetail } = getEndpointState('myAccountStoreDetail');
    const { data: myAdherences, loading: isLoadingMyAdherences } = getEndpointState('myAdherences');
    const { data: myAdherenceDetail, loading: isLoadingMyAdherenceDetail } = getEndpointState('myAdherenceDetail');
    const { data: myCoupons, loading: isLoadingMyCoupons } = getEndpointState('myCoupons');
    const { data: myCouponDetail, loading: isLoadingMyCouponDetail } = getEndpointState('myCouponDetail');
    const { data: createdStore } = getEndpointState('createdStore');
    const { data: createdProduct } = getEndpointState('createdProduct');
    const { data: createdReservations } = getEndpointState('createdReservations');
    const { data: createdCoupon } = getEndpointState('createdCoupon');
    const { data: createdService } = getEndpointState('createdService');
    const { data: createdWorker } = getEndpointState('createdWorker');
    const { data: complaintCategories } = getEndpointState('complaintCategories');
    const { data: user, loading: isLoadingUser } = getEndpointState('user');
    const { data: userPoints } = getEndpointState('userPoints');
    const { data: qrCode } = getEndpointState('qrCode');
    const { data: cartItemDetail } = getEndpointState('cartItemDetail');
    const { data: allNearbyPickupSpots } = getEndpointState('allNearbyPickupSpots');
    const { data: allLockers } = getEndpointState('allLockers');
    const { data: pickupSpotDetail } = getEndpointState('pickupSpotDetail');
    const { data: allShippingCountries } = getEndpointState('allShippingCountries');
    const { data: allPaymentMethods, loading: isLoadingAllPaymentMethods } = getEndpointState('allPaymentMethods');
    const { data: createdOrder } = getEndpointState('createdOrder');
    const { data: myOrders, loading: isLoadingMyOrders } = getEndpointState('myOrders');
    const { data: myOrderDetail, loading: isLoadingMyOrderDetail } = getEndpointState('myOrderDetail');
    const { data: myStoresOrders, loading: isLoadingMyStoresOrders } = getEndpointState('myStoresOrders');
    const { data: myStoresOrderDetail, loading: isLoadingMyStoresOrderDetail } = getEndpointState('myStoresOrderDetail');
    const { data: myProductReservations, loading: isLoadingMyProductReservations } = getEndpointState('myProductReservations');
    const { data: myProductReservationDetail, loading: isLoadingMyProductReservationDetail } =
        getEndpointState('myProductReservationDetail');
    const { data: myStoresProductReservations, loading: isLoadingMyStoresProductReservations } =
        getEndpointState('myStoresProductReservations');
    const { data: myStoresProductReservationDetail, loading: isLoadingMyStoresProductReservationDetail } = getEndpointState(
        'myStoresProductReservationDetail'
    );
    const { data: allCaes, loading: isLoadingAllCaes } = getEndpointState('allCaes');
    const { data: allZones, loading: isLoadingAllZones } = getEndpointState('allZones');
    const { data: lastUserLocationLogged } = getEndpointState('lastUserLocationLogged');
    const { loading: isLoadingCancelLockerCompartmentReservation } = getEndpointState('cancelLockerCompartmentReservation');
    const { data: pointsFaqs } = getEndpointState('pointsFaqs');
    const { data: pointsServices, loading: isLoadingPointsServices } = getEndpointState('pointsServices');

    const contextValue: DataContextProps = {
        login,
        setLogin: (data) => setEndpointState('login', { data }),

        allProductsCategories,
        isLoadingAllProductsCategories,
        setAllProductsCategories: (data) => setEndpointState('allProductsCategories', { data }),
        setIsLoadingAllProductsCategories: (loading) => setEndpointState('allProductsCategories', { loading }),

        allCategoriesWithServices,
        isLoadingAllCategoriesWithServices,
        setAllCategoriesWithServices: (data) => setEndpointState('allCategoriesWithServices', { data }),
        setIsLoadingAllCategoriesWithServices: (loading) => setEndpointState('allCategoriesWithServices', { loading }),

        allCategoriesWithProducts,
        isLoadingAllCategoriesWithProducts,
        setAllCategoriesWithProducts: (data) => setEndpointState('allCategoriesWithProducts', { data }),
        setIsLoadingAllCategoriesWithProducts: (loading) => setEndpointState('allCategoriesWithProducts', { loading }),

        allCategoriesWithPointsServices,
        isLoadingAllCategoriesWithPointsServices,
        setAllCategoriesWithPointsServices: (data) => setEndpointState('allCategoriesWithPointsServices', { data }),
        setIsLoadingAllCategoriesWithPointsServices: (loading) =>
            setEndpointState('allCategoriesWithPointsServices', { loading }),

        productCategoryMaxPrice,
        setProductCategoryMaxPrice: (data) => setEndpointState('productCategoryMaxPrice', { data }),

        pointsServicesMaxPoints,
        setPointsServicesMaxPoints: (data) => setEndpointState('pointsServicesMaxPoints', { data }),

        allServicesCategories,
        isLoadingAllServicesCategories,
        setAllServicesCategories: (data) => setEndpointState('allServicesCategories', { data }),
        setIsLoadingAllServicesCategories: (loading) => setEndpointState('allServicesCategories', { loading }),

        allLanguages,
        setAllLanguages: (data) => setEndpointState('allLanguages', { data }),

        campaignProducts,
        isLoadingCampaignProducts,
        setCampaignProducts: (data) => setEndpointState('campaignProducts', { data }),
        setIsLoadingCampaignProducts: (loading) => setEndpointState('campaignProducts', { loading }),

        allProducts,
        isLoadingAllProducts,
        setAllProducts: (data) => setEndpointState('allProducts', { data }),
        setIsLoadingAllProducts: (loading) => setEndpointState('allProducts', { loading }),

        products,
        isLoadingProducts,
        setProducts: (data) => setEndpointState('products', { data }),
        setIsLoadingProducts: (loading) => setEndpointState('products', { loading }),

        productDetail,
        setProductDetail: (data) => setEndpointState('productDetail', { data }),

        pointsServiceDetail,
        setPointsServiceDetail: (data) => setEndpointState('pointsServiceDetail', { data }),

        highlightDetail,
        setHighlightDetail: (data) => setEndpointState('highlightDetail', { data }),

        allProductAttributesByCategory,
        setAllProductAttributesByCategory: (data) => setEndpointState('allProductAttributesByCategory', { data }),

        allProductStores,
        isLoadingAllProductStores,
        setAllProductStores: (data) => setEndpointState('allProductStores', { data }),
        setIsLoadingAllProductStores: (loading) => setEndpointState('allProductStores', { loading }),

        allServiceStores,
        setAllServiceStores: (data) => setEndpointState('allServiceStores', { data }),

        allSettings,
        setAllSettings: (data) => setEndpointState('allSettings', { data }),

        allInstagramImages,
        setAllInstagramImages: (data) => setEndpointState('allInstagramImages', { data }),

        allBundles,
        setAllBundles: (data) => setEndpointState('allBundles', { data }),

        campaignBundles,
        setCampaignBundles: (data) => setEndpointState('campaignBundles', { data }),

        campaigns,
        setCampaigns: (data) => setEndpointState('campaigns', { data }),

        bundleDetail,
        setBundleDetail: (data) => setEndpointState('bundleDetail', { data }),

        stores,
        isLoadingStores,
        setStores: (data) => setEndpointState('stores', { data }),
        setIsLoadingStores: (loading) => setEndpointState('stores', { loading }),

        homepageStores,
        isLoadingHomepageStores,
        setHomepageStores: (data) => setEndpointState('homepageStores', { data }),
        setIsLoadingHomepageStores: (loading) => setEndpointState('homepageStores', { loading }),

        storesLocations,
        isLoadingStoresLocations,
        setStoresLocations: (data) => setEndpointState('storesLocations', { data }),
        setIsLoadingStoresLocations: (loading) => setEndpointState('storesLocations', { loading }),

        allStoreWorkers,
        setAllStoreWorkers: (data) => setEndpointState('allStoreWorkers', { data }),

        allStoreSchedulableWorkers,
        setAllStoreSchedulableWorkers: (data) => setEndpointState('allStoreSchedulableWorkers', { data }),

        storeDetail,
        isLoadingStoreDetail,
        setStoreDetail: (data) => setEndpointState('storeDetail', { data }),
        setIsLoadingStoreDetail: (loading) => setEndpointState('storeDetail', { loading }),

        servicesToBook,
        isLoadingServicesToBook,
        setServicesToBook: (data) => setEndpointState('servicesToBook', { data }),
        setIsLoadingServicesToBook: (loading) => setEndpointState('servicesToBook', { loading }),

        servicesCartTotals,
        isLoadingServicesCartTotals,
        setServicesCartTotals: (data) => setEndpointState('servicesCartTotals', { data }),
        setIsLoadingServicesCartTotals: (loading) => setEndpointState('servicesCartTotals', { loading }),

        allGeoDistricts,
        setAllGeoDistricts: (data) => setEndpointState('allGeoDistricts', { data }),

        allGeoMunicipalitiesOfDistrict,
        setAllGeoMunicipalitiesOfDistrict: (data) => setEndpointState('allGeoMunicipalitiesOfDistrict', { data }),

        allCarouselData,
        setAllCarouselData: (data) => setEndpointState('allCarouselData', { data }),

        allServices,
        isLoadingAllServices,
        setAllServices: (data) => setEndpointState('allServices', { data }),
        setIsLoadingAllServices: (loading) => setEndpointState('allServices', { loading }),

        serviceStores,
        isLoadingServiceStores,
        setServiceStores: (data) => setEndpointState('serviceStores', { data }),
        setIsLoadingServiceStores: (loading) => setEndpointState('serviceStores', { loading }),

        myPoints,
        setMyPoints: (data) => setEndpointState('myPoints', { data }),

        addresses,
        setAddresses: (data) => setEndpointState('addresses', { data }),

        addressesEdit,
        isLoadingAddressesEdit,
        setAddressesEdit: (data) => setEndpointState('addressesEdit', { data }),
        setIsLoadingAddressesEdit: (loading) => setEndpointState('addressesEdit', { loading }),

        addressesCreate,
        setAddressesCreate: (data) => setEndpointState('addressesCreate', { data }),

        addressesDetail,
        isLoadingAddressesDetail: false,
        setAddressesDetail: (data) => setEndpointState('addressesDetail', { data }),
        setIsLoadingAddressesDetail: (loading) => setEndpointState('addressesDetail', { loading }),

        cart,
        setCart: (data) => setEndpointState('cart', { data }),

        storeSchedule,
        isLoadingStoreSchedule,
        setStoreSchedule: (data) => setEndpointState('storeSchedule', { data }),
        setIsLoadingStoreSchedule: (loading) => setEndpointState('storeSchedule', { loading }),

        myAccountProducts,
        isLoadingMyAccountProducts,
        setMyAccountProducts: (data) => setEndpointState('myAccountProducts', { data }),
        setIsLoadingMyAccountProducts: (loading) => setEndpointState('myAccountProducts', { loading }),

        myAccountDashboardIndicators,
        isLoadingMyAccountDashboardIndicators,
        setMyAccountDashboardIndicators: (data) => setEndpointState('myAccountDashboardIndicators', { data }),
        setIsLoadingMyAccountDashboardIndicators: (loading) => setEndpointState('myAccountDashboardIndicators', { loading }),

        myAccountDashboardCharts,
        isLoadingMyAccountDashboardCharts,
        setMyAccountDashboardCharts: (data) => setEndpointState('myAccountDashboardCharts', { data }),
        setIsLoadingMyAccountDashboardCharts: (loading) => setEndpointState('myAccountDashboardCharts', { loading }),

        myAccountWorkers,
        isLoadingMyAccountWorkers,
        setMyAccountWorkers: (data) => setEndpointState('myAccountWorkers', { data }),
        setIsLoadingMyAccountWorkers: (loading) => setEndpointState('myAccountWorkers', { loading }),

        myAccountStoreSchedule,
        isLoadingMyAccountStoreSchedule,
        setMyAccountStoreSchedule: (data) => setEndpointState('myAccountStoreSchedule', { data }),
        setIsLoadingMyAccountStoreSchedule: (loading) => setEndpointState('myAccountStoreSchedule', { loading }),

        myAccountServices,
        isLoadingMyAccountServices,
        setMyAccountServices: (data) => setEndpointState('myAccountServices', { data }),
        setIsLoadingMyAccountServices: (loading) => setEndpointState('myAccountServices', { loading }),

        myAccountServiceDetail,
        isLoadingMyAccountServiceDetail,
        setMyAccountServiceDetail: (data) => setEndpointState('myAccountServiceDetail', { data }),
        setIsLoadingMyAccountServiceDetail: (loading) => setEndpointState('myAccountServiceDetail', { loading }),

        myAccountProductDetail,
        isLoadingMyAccountProductDetail,
        setMyAccountProductDetail: (data) => setEndpointState('myAccountProductDetail', { data }),
        setIsLoadingMyAccountProductDetail: (loading) => setEndpointState('myAccountProductDetail', { loading }),

        myAccountWorkerDetail,
        isLoadingMyAccountWorkerDetail,
        setMyAccountWorkerDetail: (data) => setEndpointState('myAccountWorkerDetail', { data }),
        setIsLoadingMyAccountWorkerDetail: (loading) => setEndpointState('myAccountWorkerDetail', { loading }),

        allMyAccountStores,
        isLoadingAllMyAccountStores,
        setAllMyAccountStores: (data) => setEndpointState('allMyAccountStores', { data }),
        setIsLoadingAllMyAccountStores: (loading) => setEndpointState('allMyAccountStores', { loading }),

        myAccountStoreDetail,
        isLoadingMyAccountStoreDetail,
        setMyAccountStoreDetail: (data) => setEndpointState('myAccountStoreDetail', { data }),
        setIsLoadingMyAccountStoreDetail: (loading) => setEndpointState('myAccountStoreDetail', { loading }),

        myAdherences,
        isLoadingMyAdherences,
        setMyAdherences: (data) => setEndpointState('myAdherences', { data }),
        setIsLoadingMyAdherences: (loading) => setEndpointState('myAdherences', { loading }),

        myAdherenceDetail,
        isLoadingMyAdherenceDetail,
        setMyAdherenceDetail: (data) => setEndpointState('myAdherenceDetail', { data }),
        setIsLoadingMyAdherenceDetail: (loading) => setEndpointState('myAdherenceDetail', { loading }),

        myCoupons,
        isLoadingMyCoupons,
        setMyCoupons: (data) => setEndpointState('myCoupons', { data }),
        setIsLoadingMyCoupons: (loading) => setEndpointState('myCoupons', { loading }),

        myCouponDetail,
        isLoadingMyCouponDetail,
        setMyCouponDetail: (data) => setEndpointState('myCouponDetail', { data }),
        setIsLoadingMyCouponDetail: (loading) => setEndpointState('myCouponDetail', { loading }),

        createdStore,
        setCreatedStore: (data) => setEndpointState('createdStore', { data }),

        createdProduct,
        setCreatedProduct: (data) => setEndpointState('createdProduct', { data }),

        createdReservations,
        setCreatedReservations: (data) => setEndpointState('createdReservations', { data }),

        createdCoupon,
        setCreatedCoupon: (data) => setEndpointState('createdCoupon', { data }),

        createdService,
        setCreatedService: (data) => setEndpointState('createdService', { data }),

        createdWorker,
        setCreatedWorker: (data) => setEndpointState('createdWorker', { data }),

        complaintCategories,
        setComplaintCategories: (data) => setEndpointState('complaintCategories', { data }),

        user,
        isLoadingUser,
        setUser: (data) => setEndpointState('user', { data }),
        setIsLoadingUser: (loading) => setEndpointState('user', { loading }),

        userPoints,
        setUserPoints: (data) => setEndpointState('userPoints', { data }),

        qrCode,
        setQrCode: (data) => setEndpointState('qrCode', { data }),

        cartItemDetail,
        setCartItemDetail: (data) => setEndpointState('cartItemDetail', { data }),

        allNearbyPickupSpots,
        setAllNearbyPickupSpots: (data) => setEndpointState('allNearbyPickupSpots', { data }),

        allLockers,
        setAllLockers: (data) => setEndpointState('allLockers', { data }),

        pickupSpotDetail,
        setPickupSpotDetail: (data) => setEndpointState('pickupSpotDetail', { data }),

        allShippingCountries,
        setAllShippingCountries: (data) => setEndpointState('allShippingCountries', { data }),

        allPaymentMethods,
        isLoadingAllPaymentMethods,
        setAllPaymentMethods: (data) => setEndpointState('allPaymentMethods', { data }),
        setIsLoadingAllPaymentMethods: (loading) => setEndpointState('allPaymentMethods', { loading }),

        createdOrder,
        setCreatedOrder: (data) => setEndpointState('createdOrder', { data }),

        myOrders,
        isLoadingMyOrders,
        setMyOrders: (data) => setEndpointState('myOrders', { data }),
        setIsLoadingMyOrders: (loading) => setEndpointState('myOrders', { loading }),

        myOrderDetail,
        isLoadingMyOrderDetail,
        setMyOrderDetail: (data) => setEndpointState('myOrderDetail', { data }),
        setIsLoadingMyOrderDetail: (loading) => setEndpointState('myOrderDetail', { loading }),

        myStoresOrders,
        isLoadingMyStoresOrders,
        setMyStoresOrders: (data) => setEndpointState('myStoresOrders', { data }),
        setIsLoadingMyStoresOrders: (loading) => setEndpointState('myStoresOrders', { loading }),

        myStoresOrderDetail,
        isLoadingMyStoresOrderDetail,
        setMyStoresOrderDetail: (data) => setEndpointState('myStoresOrderDetail', { data }),
        setIsLoadingMyStoresOrderDetail: (loading) => setEndpointState('myStoresOrderDetail', { loading }),

        myProductReservations,
        isLoadingMyProductReservations,
        setMyProductReservations: (data) => setEndpointState('myProductReservations', { data }),
        setIsLoadingMyProductReservations: (loading) => setEndpointState('myProductReservations', { loading }),

        myProductReservationDetail,
        isLoadingMyProductReservationDetail,
        setMyProductReservationDetail: (data) => setEndpointState('myProductReservationDetail', { data }),
        setIsLoadingMyProductReservationDetail: (loading) => setEndpointState('myProductReservationDetail', { loading }),

        myStoresProductReservations,
        isLoadingMyStoresProductReservations,
        setMyStoresProductReservations: (data) => setEndpointState('myStoresProductReservations', { data }),
        setIsLoadingMyStoresProductReservations: (loading) => setEndpointState('myStoresProductReservations', { loading }),

        myStoresProductReservationDetail,
        isLoadingMyStoresProductReservationDetail,
        setMyStoresProductReservationDetail: (data) => setEndpointState('myStoresProductReservationDetail', { data }),
        setIsLoadingMyStoresProductReservationDetail: (loading) =>
            setEndpointState('myStoresProductReservationDetail', { loading }),

        allCaes,
        isLoadingAllCaes,
        setAllCaes: (data) => setEndpointState('allCaes', { data }),
        setIsLoadingAllCaes: (loading) => setEndpointState('allCaes', { loading }),

        allZones,
        isLoadingAllZones,
        setAllZones: (data) => setEndpointState('allZones', { data }),
        setIsLoadingAllZones: (loading) => setEndpointState('allZones', { loading }),

        lastUserLocationLogged,
        setLastUserLocationLogged: (data) => setEndpointState('lastUserLocationLogged', { data }),

        isLoadingCancelLockerCompartmentReservation,
        setIsLoadingCancelLockerCompartmentReservation: (loading) =>
            setEndpointState('cancelLockerCompartmentReservation', { loading }),

        pointsFaqs,
        setPointsFaqs: (data) => setEndpointState('pointsFaqs', { data }),

        pointsServices,
        isLoadingPointsServices,
        setPointsServices: (data) => setEndpointState('pointsServices', { data }),
        setIsLoadingPointsServices: (loading) => setEndpointState('pointsServices', { loading }),
    };

    return <DataContext.Provider value={contextValue}>{children}</DataContext.Provider>;
};
